// extracted by mini-css-extract-plugin
export var orderSummary = "_qz-0";
export var showMoreLessButton = "_qz-1";